<template>
  <div class="border md:flex my-4 py-3 bg-white">
    <div class="md:w-1/4 text-center self-center">
      <div
        class="flex text-lg justify-center p-3 md:p-0 group"
        :class="{ 'hover:text-blue-600 cursor-pointer': totalIsLink }"
        @click="$emit('total-clicked')"
        v-tooltip="tooltip"
      >
        <div class="font-semibold mr-2">{{ stats.total }}</div>
        <div
          class="text-gray-500"
          :class="{ 'group-hover:text-blue-500': totalIsLink }"
        >{{ stats.total == 1 ? 'Dossier' : 'Dossiers' }}</div>
      </div>
    </div>
    <div class="hidden sm:block md:w-3/4 text-center self-center border-l border-gray-200">
      <div class="flex flex-wrap ml-5">
        <button
          @click="$emit('change-status', status.id)"
          class="border rounded py-1 px-3 mx-1 hover:border-gray-800"
          v-for="status in statuses"
          :key="status.id"
          v-tooltip="status.contacts_count"
        >{{ status.name }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stats: {
      type: Object
    },
    status: {
      type: [String, Number]
    },
    totalIsLink: {
      type: Boolean
    }
  },

  computed: {
    statuses() {
      return this.stats.statuses || [];
    },

    tooltip() {
      let people = 'Geen particulieren';

      // if (this.stats.organizations_count == 1) {
      //   organizations = "1 organisatie";
      // } else if (this.stats.organizations_count > 1) {
      //   organizations = this.stats.organizations_count + " organisaties";
      // }

      if (this.stats.people_count == 1) {
        people = "1 particulier";
      } else if (this.stats.people_count > 1) {
        people = this.stats.people_count + " particulieren";
      }

      // if (organizations && people) return organizations + " - " + people;

      // if (organizations) return organizations;

      return people;
    }
  }
};
</script>
